import EBarOtherAnnouncementsCTA from './EBarOtherAnnouncementsCTA';

export default EBarOtherAnnouncementsCTA;
